var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{attrs:{"datetime":_vm.isoFormat}},[_vm._t("prepend"),_vm._v(_vm._s(_vm.finalValue)),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }